import './NoSlotsAvailable_Page.css';
import Icons_Repository from '../Icons/Icons_Repository';
function NoSlotsAvailable_Page(){
    return (
        <div className='no-slots-available-page-container'>

        
            <div className="no-slots-available-page">
                <div className="no-slots-available-card">
                    <div className="no-slots-available-header">
                        <div className='calendar-icon'>
                            <Icons_Repository iconName='calendar' />
                        </div>
                        <div className="no-slots-available-title">
                            <h2>No Slots Available</h2>
                        </div>

                    </div>
                    <div className='no-slots-available-body'>
                        <div className='no-slots-available-body-text'>
                            We would like to inform you that currently, there are no slots available for the applied role. Please review this page periodically for any future openings.
                        </div>
                    </div>
                    {/* <p className="cancelled-text">
                        Your scheduled interview has been successfully cancelled. 
                    </p>

                    <p className="cancelled-subtext">
                        A confirmation email has been sent to your mail. Feel free to reschedule anytime.
                    </p> */}

                </div>
            </div>
        </div>
    )
}
export default NoSlotsAvailable_Page